import { connect, useDispatch } from "react-redux";
import { State } from "redux/store";

import {
  getResourceConfiguration,
  getShowResourceConfigurationModal,
} from "redux/CreateDataset/selectors";
import {
  setResourceConfiguration,
  setShowResourceConfigurationModal,
} from "redux/CreateDataset/actions";
import {
  ResourceConfiguration,
  getSelectedPreset,
  isDefaultResourceConfiguration,
} from "../../../../../helpers/constants/resourceConfiguration";
import ResourceConfigurationModal from "../../../../modals/ResourceConfigurationModal";

import styles from "./style.module.scss";

interface ResourceConfigurationBarProps {
  resourceConfiguration: ResourceConfiguration;
  showResourceConfigurationModal: boolean;
}

const ResourceConfigurationBar = ({
  resourceConfiguration,
  showResourceConfigurationModal,
}: ResourceConfigurationBarProps) => {
  const dispatch = useDispatch();

  const handleOpenResourceModal = () => {
    dispatch(setShowResourceConfigurationModal(true));
  };

  const handleSaveResourceConfiguration = (config: ResourceConfiguration) => {
    dispatch(setResourceConfiguration(config));
  };

  const handleCloseResourceModal = () => {
    dispatch(setShowResourceConfigurationModal(false));
  };

  const selectedPreset = getSelectedPreset(resourceConfiguration);
  const isDefault = isDefaultResourceConfiguration(resourceConfiguration);

  // Only show configuration if it's been changed from default
  const hasConfiguration = !isDefault;

  return (
    <div className={styles.resourceBar}>
      <div className={styles.resourceSection}>
        <div className={styles.resourceInfo}>
          <h3 className={styles.resourceTitle}>
            Advanced Configuration (internal only)
          </h3>
        </div>

        <button
          className={styles.configureButton}
          onClick={handleOpenResourceModal}
        >
          <div className={styles.buttonContent}>
            <div className={styles.buttonTitle}>
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
              </svg>
              Configure Resources
            </div>
            {hasConfiguration && (
              <div className={styles.buttonSubtitle}>
                {selectedPreset ? (
                  <>
                    <span className={styles.presetBadge}>
                      {selectedPreset.toUpperCase()}
                    </span>
                    <span className={styles.resourceText}>
                      {resourceConfiguration.cpu}CPU •{" "}
                      {resourceConfiguration.memory}GB
                      {resourceConfiguration.disk
                        ? ` • ${resourceConfiguration.disk}GB disk`
                        : " • Default disk"}
                    </span>
                  </>
                ) : (
                  <>
                    <span className={styles.customBadge}>CUSTOM</span>
                    <span className={styles.resourceText}>
                      {resourceConfiguration.cpu}CPU •{" "}
                      {resourceConfiguration.memory}GB
                      {resourceConfiguration.disk
                        ? ` • ${resourceConfiguration.disk}GB disk`
                        : " • Default disk"}
                    </span>
                  </>
                )}
              </div>
            )}
          </div>
        </button>
      </div>

      <ResourceConfigurationModal
        showModal={showResourceConfigurationModal}
        setShowModal={handleCloseResourceModal}
        onSave={handleSaveResourceConfiguration}
        initialConfig={resourceConfiguration}
      />
    </div>
  );
};

const mapStateToProps = (state: State) => {
  return {
    resourceConfiguration: getResourceConfiguration(state),
    showResourceConfigurationModal: getShowResourceConfigurationModal(state),
  };
};

export default connect(mapStateToProps)(ResourceConfigurationBar);
